import { every } from "lodash";

export default function getSubscriptionEnabledForChannels({
  subscriptions,
  type,
  channels,
  defaultEnabled = true
}) {
  if (!Array.isArray(subscriptions)) {
    return defaultEnabled;
  }

  const matchingSubscriptions = subscriptions.filter(
    subscription =>
      subscription.type === type &&
      channels.indexOf(subscription.channel) !== -1
  );

  if (matchingSubscriptions.length === 0) {
    return defaultEnabled;
  }

  return every(matchingSubscriptions, subscription => subscription.status);
}
